<template>
    <div class="containContent">
        <div class="tit xy-between">
            <div class="sheetTextjf">
                <div class="spare"></div>
                <div class="text font-size16">答题卡</div>
            </div>
        </div>
        <div class="showMakeStatu ">
            <div v-if="isSubmit" class="sparBox jf ">
                <div class="err jf">
                    <div class="btnDote"></div>
                    <div>错误</div>
                </div>
                <div class="right jf">
                    <div class="btnDote statu"></div>
                    <div>正确</div>

                </div>
                <div class="notMake jf statu">
                    <div class="btnDote"></div>
                    <div>未做</div>
                </div>

                <div class="haveDo jf statu">
                    <div class="btnDote"></div>
                    <div>已做</div>
                </div>
            </div>
            <div v-else class="sparBox jf ">
                <div class="haveDo jf">
                    <div class="btnDote"></div>
                    <div>已做</div>
                </div>
                <div class="notMake jf statu">
                    <div class="btnDote"></div>
                    <div>未做</div>
                </div>
            </div>
        </div>
        <!-- 题型 -->
        <div class="topicType">
            <div class="mt-5">
                <div v-if="info.allQuestions !==1" class="TopicBox">
                    <div class="box" v-for="(value, key) in getQuestions" :key="key">
                        <div class="text">{{ key }}</div>
                        <div class="toipicBox">
                            <div v-for="(item,index) in value" :key="index"
                                 :class="{'active': currentOrder === item.order || item.haveDo,
                                 'errStyle': ([1, 2, 4].includes(parseInt(item.SubjectType))) ? (item.status && item.isErr === 1 && item.haveDo): false,
                                 'rightStyle': ([1, 2, 4].includes(parseInt(item.SubjectType))) ? item.status && item.isErr===0 && item.haveDo : false
                            }"
                                 class="topicItem xy-center c-868EA1 font-size16" @click="selectOrder(item.order)">
                                <div>{{ item.order }}</div>
                            </div>
                        </div>
                    </div>
                    <!--                    <div>-->
                    <!--                        <div v-if="singleTopic && singleTopic.length" class="box">-->
                    <!--                            <div class="text">单选题</div>-->
                    <!--                            <div class="toipicBox">-->
                    <!--                                <div v-for="(item,i) in singleTopic" :key="i"-->
                    <!--                                     :class="{'active': currentOrder === item.order ||  item.haveDo,'errStyle': item.status && item.isErr === 1 && item.haveDo,'rightStyle': item.status && item.isErr===0 && item.haveDo}"-->
                    <!--                                     class="topicItem xy-center c-868EA1 font-size16" @click="selectOrder(item.order)">-->
                    <!--                                    <div>{{ i + 1 }}</div>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div v-if="multiSelect && multiSelect.length" class="box">-->
                    <!--                        <div class="text">多选题</div>-->
                    <!--                        <div class="toipicBox">-->
                    <!--                            <div v-for="(item,i) in multiSelect" :key="i"-->
                    <!--                                 :class="{'active': currentOrder === item.order ||  item.haveDo,'errStyle': item.status && item.isErr === 1 && item.haveDo,'rightStyle': item.status && item.isErr === 0 && item.haveDo}"-->
                    <!--                                 class="topicItem xy-center c-868EA1 font-size16" @click="selectOrder(item.order)">-->
                    <!--                                <div>{{ i + 1 }}</div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <!--                    <div v-if="judgeTopic && judgeTopic.length" class="box">-->
                    <!--                        <div class="text">判断题</div>-->
                    <!--                        <div class="toipicBox">-->
                    <!--                            <div v-for="(item,i) in judgeTopic" :key="i"-->
                    <!--                                 :class="{'active': currentOrder === item.order ||  item.haveDo,'errStyle': item.status && item.isErr ===1 && item.haveDo,'rightStyle': item.status && item.isErr===0 && item.haveDo}"-->
                    <!--                                 class="topicItem xy-center c-868EA1 font-size16" @click="selectOrder(item.order)">-->
                    <!--                                <div>{{ i + 1 }}</div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <!--                    <div v-if="fillTpic && fillTpic.length" class="box">-->
                    <!--                        <div class="text">填空题</div>-->
                    <!--                        <div class="toipicBox">-->
                    <!--                            <div v-for="(item,i) in fillTpic" :key="i"-->
                    <!--                                 :class="{'active': currentOrder === item.order ||  item.haveDo ,}"-->
                    <!--                                 class="topicItem xy-center c-868EA1 font-size16" @click="selectOrder(item.order)">-->
                    <!--                                <div>{{ i + 1 }}</div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <!--                    <div v-if="shortTopic && shortTopic.length" class="box">-->
                    <!--                        <div class="text">问答题</div>-->
                    <!--                        <div>-->
                    <!--                            <div class="toipicBox">-->
                    <!--                                <div v-for="(item,i) in shortTopic" :key="i"-->
                    <!--                                     :class="{'active': currentOrder === item.order ||  item.haveDo, }"-->
                    <!--                                     class="topicItem xy-center c-868EA1 font-size16" @click="selectOrder(item.order)">-->
                    <!--                                    <div>{{ i + 1 }}</div>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </div>
                <div v-else class="TopicBox">
                    <div class="box">
                        <div class="toipicBox">
                            <div v-for="(item,i) in sheetList" :key="i"
                                 :class="{'active': currentOrder === item.order ||  item.haveDo,'errStyle': item.status && item.isErr === 1 &&   item.haveDo  && item.SubjectType !=='3' && item.SubjectType !=='5' ,'rightStyle': item.status && item.isErr === 0 &&  item.haveDo && item.SubjectType !=='3' && item.SubjectType !=='5', }"
                                 class="topicItem xy-center c-868EA1 font-size16" @click="selectOrder(item.order)">
                                <div>{{ i + 1 }}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {
    GetMedicalQueationDetailByClassId,
    DeleteErrSubjectLog,
    DeleteErrSubjectLogArray
} from "@/api/course"
import {
    GetRandomExam
} from "@/api/exam"

export default {
    props: {
        info: {
            type: Object,
            default: () => {
            }
        },
        serialNumber: {
            type: Number,
            default: 0
        },
        list: {
            type: Array,
            default: () => []
        },
        testOver: {
            type: Array,
            default: () => []
        },
        isDo: {
            type: Object,
            default: () => {
            }
        },
        isSubmit: {
            type: Boolean,
            default: false
        }
    },
    components: {},
    data() {
        return {
            allTopic: [],
            currentOrder: "",
            singleTopic: [],
            multiSelect: [],
            fillTpic: [],
            judgeTopic: [],
            shortTopic: [],
            sheetAllTopic: [],
            topicTypes: []
        }
    },
    watch: {
        isSubmit(val) {
            console.log("val-", val);
        },
        isDo(val) {
            this.sheetList.forEach((v, i) => {
                if (v.id === val.id) {
                    if (val.haveDo) {
                        v.haveDo = true
                    } else {
                        v.haveDo = false
                    }
                }
            })
            this.$forceUpdate()
        },
        "testOver.length": {
            handler() {
                this.sheetList = this.testOver
                this.sheetList.forEach((v, i) => {
                    if (v.SubjectType === "3" || v.SubjectType === "5") {
                        // 对填空题或者简答题的正确与否不做判断
                        v.isErr = null
                    }
                })
                this.$forceUpdate()
            }
        },

        serialNumber(val) {
            console.log(val, "value");
            this.currentOrder = val
        }
    },
    computed: {
        sheetList: {
            get() {
                return this.list
            },
            set(newValue) {
                this.list = newValue
            }
        },
        getQuestions({ list = [] }) {
            return list.reduce((preVal, curVal, index) => {
                const key = this.getQuestionText(curVal.SubjectType)
                curVal.order = index + 1
                if (Array.isArray(preVal[key])) {
                    preVal[key].push(curVal)
                } else {
                    preVal[key] = [curVal]
                }
                return preVal
            }, {})
        }
    },
    created() {
        this.topicTypes = [...new Set(this.info.topicTypes)]
        if (this.info.allQuestions !== 1 && this.topicTypes && this.topicTypes.length !== 0) {
            console.log(this.sheetList, "this.sheetList");
            this.topicTypes.forEach(c => {
                this.sheetList.forEach((v, i) => {
                    if (v.SubjectType === "1" && c === "0") {
                        this.singleTopic.push(v)
                    }
                    if (v.SubjectType === "2" && c === "1") {
                        this.multiSelect.push(v)
                    }
                    if (v.SubjectType === "3" && c === "3") {
                        this.fillTpic.push(v)
                    }
                    if (v.SubjectType === "4" && c === "5") {
                        this.judgeTopic.push(v)
                    }
                    if (v.SubjectType === "5" && c === "4") {
                        this.shortTopic.push(v)
                    }
                })
            })
            this.resetOrder()
        } else {
        }
    },
    mounted() {
        if (this.serialNumber) {
            this.currentOrder = this.serialNumber
        } else {
            this.currentOrder = 1
        }
    },
    updated() {
    },
    methods: {
        resetMake() {
            this.$confirm("重做后做题记录和错题记录将重新更新，是否要重做？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.confrimRemake()
            }).catch(() => {

            });
        },
        resetOrder() {
            let order = 1
            const setOrder = (arr) => {
                arr.forEach(el => {
                    el.order = order++
                })
            }
            setOrder(this.singleTopic)
            setOrder(this.multiSelect)
            setOrder(this.judgeTopic)
            setOrder(this.fillTpic)
            setOrder(this.shortTopic)
        },
        getQuestionText(type) {
            const questionMap = {
                1: "单选题",
                2: "多选题",
                3: "填空题",
                4: "判断题",
                5: "问答题"
            }
            return questionMap[type]
        },
        async confrimRemake() {
            try {
                const {
                    data
                } = await DeleteErrSubjectLog({
                    chapterId: this.info.columId
                })
            } catch (error) {
                console.log(error);
            }
        },
        findFristNotMake() {

        },
        async GetRandomExam() {
            try {
                const {
                    data
                } = await GetRandomExam({
                    randomExamId: this.info.columId
                });
                let arr = data.data
                let arrMap = []
                arr.forEach((v, i) => {
                    if (v.subjectListCS && v.subjectListCS.length) {
                        v.subjectListCS.forEach((c, i) => {
                            arrMap.push(c)
                        })
                    }
                });
                this.allTopic = arrMap
                this.allTopic.forEach((v, i) => {
                    v.order = parseInt(i) + 1
                })
            } catch (error) {
                console.log(error);
            }
        },
        // 本页面暂未使用
        async GetMedicalQueationDetailByClassId() {
            try {
                const {
                    data
                } = await GetMedicalQueationDetailByClassId({
                    chapterId: this.info.info.id,
                    pageno: 1,
                    pagesize: 99999
                });
                this.allTopic = data.data
                this.allTopic.forEach((v, i) => {
                    v.order = parseInt(i) + 1
                })
            } catch (error) {
                console.log(error);
            }
        },
        selectOrder(val) {
            this.currentOrder = val
            this.$emit("jumoTopic", val)
        }
    }
}

</script>

<style scoped lang="less">
.containContent {
    .tit {
        padding: 30px 30px 0 30px;
        box-sizing: border-box;

        .sheetText {
            .spare {
                width: 4px;
                height: 18px;
                background: #256CF4;
            }
        }

        .resetBtn {
            width: 60px;
            height: 30px;
            background: #F9F9FA;
            border-radius: 8px;
            border: 1px solid #256CF4;
            color: #256CF4;
        }
    }

    .showMakeStatu {
        padding-left: 30px;
        box-sizing: border-box;
        margin-top: 20px;
        height: 50px;
        display: flex;
        align-items: center;
        border-top: 1px solid #E5E8EC;
        border-bottom: 1px solid #E5E8EC;

        .sparBox {
            font-size: 14px;

            .statu {
                margin-left: 15px;
            }
        }

        .btnDote {
            width: 15px;
            height: 15px;
            border-radius: 2px;
            margin-right: 4px;
        }

        .err {
            .btnDote {
                background: #F33737;
            }
        }

        .haveDo {
            .btnDote {
                background-color: #256CF4;
            }
        }

        .right {
            .btnDote {
                background: #00B37C;
            }
        }

        .notMake {
            .btnDote {
                background: #FFFFFF;
                border: 1px solid #E5E8EC;
            }
        }
    }

    .topicType {
        padding: 0px 30px 30px 30px;
        box-sizing: border-box;
        height: 640px;
        overflow: auto;

        .TopicBox {

            .box {
                overflow: hidden;

                .text {
                    margin-top: 20px;
                    font-size: 16px;
                }

                .toipicBox {
                    // display: flex;
                    flex-direction: row;
                    //两侧对齐
                    justify-content: space-between;
                    //自动换行
                    flex-wrap: wrap;
                    //清除上下行的中间空隙
                    align-content: flex-start;
                }

                // .toipicBox:after {
                //     content: '';
                //     width: 150px;
                //     height: 0;
                //     visibility: hidden;
                // }

            }

            .topicItem {
                float: left;
                width: 30px;
                height: 30px;
                background: #FFFFFF;
                border-radius: 8px;
                border: 1px solid #E5E8EC;
                margin-right: 15px;
                margin-top: 20px;
                cursor: pointer;
                box-sizing: border-box;
            }

            .active {
                background-color: #256CF4;
                color: #fff;
            }

            .errStyle {
                background-color: #F7593B;
                color: white;
            }

            .rightStyle {
                background-color: #00B37C;
                color: white;
            }

        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            border-radius: 6px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 6px;
            background: #BAC0CA;
        }
    }
}

</style>
